{
  "home": {
    "tagline": "Over 1 million hundeeiere trener med Hundeo",
    "subline": "Anbefalt av ekte hundetrenere",
    "appStorePrefix": "Last ned på",
    "playStorePrefix": "Få den på",
    "qrHint": "Åpne appen på telefonen",
    "qrCaption": "Skann koden med kameraet",
    "socialProof": "5 000+ femstjerners anmeldelser",
    "imprint": "Imprint",
    "privacy": "Personvern",
    "language": "Språk",
    "openWebsite": "Til nettsiden",
    "openInApp": "Åpne i Hundeo-appen",
    "openInAppHint": "Du sendes videre til appen din",
    "openInAppButton": "Åpne",
    "promoRedirectTitle": "Tilbudet ditt åpnes …",
    "promoRedirectButton": "Gå til tilbudet"
  }
}
